import { createSlice } from "@reduxjs/toolkit";
export const dialogSlice = createSlice({
    name: 'dialog',
    initialState: null,
    reducers: {
        openDialog: (_, { payload }) => payload,
        closeDialog: () => null,
    },
    selectors: {
        getDialog: (state) => state,
    },
});
//# sourceMappingURL=dialogSlice.js.map